import { useMemo } from 'react';

import { collection, query, where, orderBy, Query, documentId } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useData } from '../contextProviders/DataProvider';
import { firestore } from '../firebase';
import Org from '../types/Org';

export default function useOrgsWithAdminRights() {
  const { getAdminOrgs } = useData();

  const adminOrgs = getAdminOrgs();

  const orgsQuery = useMemo(() => {
    if (!adminOrgs.length) return null;

    return query(
      collection(firestore, 'org'),
      where(documentId(), 'in', adminOrgs),
      orderBy('name')
    );
  }, [adminOrgs]);

  const [orgs, isOrgsLoading, orgsError] = useCollectionData<Org>(orgsQuery as Query<Org>);

  return {
    orgs,
    isOrgsLoading,
    orgsError,
  };
}
